export default __webpack_public_path__ + "static/media/guitar_3.1f0e17ea.png";